document.addEventListener("DOMContentLoaded", function () {
    const siteHeader = document.querySelector(".site-header");

    if (!siteHeader) return;

    function handleHeaderScroll() {
        // Toggle scrolled class when user scrolls down more than 20px
        if (window.scrollY > 20) {
            siteHeader.classList.add("site-header--scrolled");
        } else {
            siteHeader.classList.remove("site-header--scrolled");
        }
    }

    // Run on initial page load (in case user reloads mid-page)
    handleHeaderScroll();

    // Listen for scroll events with passive performance optimization
    window.addEventListener("scroll", handleHeaderScroll, { passive: true });
});
